import { Search, Layers, LineChart, Plane, Gavel, FileSearch, FileText, Crown, Award } from 'lucide-react';

export const VIDEO_URL_WIDE = '/media/hero-wide.mp4?v=5';
export const VIDEO_URL_SQUARE = '/media/hero-square.mp4?v=5';
export const VIDEO_URL = VIDEO_URL_WIDE;

// Icon + numbering metadata for the Services grid.
// Text content lives in /src/i18n/locales/*.json under `services.items`.
export const SERVICES_META = [
  { n: '01', icon: Search },
  { n: '02', icon: Layers },
  { n: '03', icon: LineChart },
  { n: '04', icon: Plane },
  { n: '05', icon: Gavel },
  { n: '06', icon: FileSearch },
  { n: '07', icon: FileText },
];

// Image URLs used by the Asset Classes grid (text in i18n).
export const ASSET_IMAGES = [
  'https://images.unsplash.com/photo-1497366216548-37526070297c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400',
  'https://images.unsplash.com/photo-1565891741441-64926e441838?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400',
  'https://images.unsplash.com/photo-1582407947304-fd86f028f716?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400',
];

// Prices and images are kept untranslated. Other text (suburb, type, detail,
// client) is in i18n under `referrals.items`.
export const REFERRAL_META = [
  { price: '$2.1M', img: 'https://images.unsplash.com/photo-1758789667762-56175fe4601c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400' },
  { price: '$1.35M', img: 'https://images.unsplash.com/photo-1772112922924-aad44f80d5bc?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400' },
  { price: '$980k', img: 'https://images.unsplash.com/photo-1761396716215-9ccb2a7eda9d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400' },
  { price: '$1.7M', img: 'https://images.unsplash.com/photo-1560179707-f14e90ef3623?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400' },
];

// Stat figures stay as English/numeric; labels are in i18n `process.stats`.
export const STATS_KEYS = ['$420M+', '180+', '5.4%', '100%'];

// Package icon/fee/accent — translatable text in i18n `pricing.packages`.
export const PACKAGES_META = [
  { id: 'platinum', icon: Crown, fee: '3%', accent: '#5FE0C8', highlight: true },
  { id: 'gold', icon: Award, fee: '2%', accent: '#C9A14A', highlight: false },
];
